import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const InlineCode = makeShortcode("InlineCode");
const Link = makeShortcode("Link");
const PropsTableAsRow = makeShortcode("PropsTableAsRow");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {UnderlineNav} from '@primer/react/drafts'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Simple`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item aria-current="page">Code</UnderlineNav.Item>
  <UnderlineNav.Item>Issues</UnderlineNav.Item>
  <UnderlineNav.Item>Pull Requests</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`With Icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item aria-current="page" icon={CodeIcon}>
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={IssueOpenedIcon} counter={30}>
    Issues
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={GitPullRequestIcon} counter={3}>
    Pull Requests
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={CommentDiscussionIcon}>Discussions</UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={9}>
    Actions
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={7}>
    Projects
  </UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`Overflow Behaviour`}</h3>
    <p>{`Component first hides icons if they present to optimize for space and show as many items as possible. If there is still an overflow, it will display the items that don't fit in the `}<inlineCode parentName="p">{`More`}</inlineCode>{` menu.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "noinline live drafts",
        "noinline": true,
        "live": true,
        "drafts": true
      }}>{`const Navigation = () => {
  const items = [
    {navigation: 'Code', icon: CodeIcon},
    {navigation: 'Issues', icon: IssueOpenedIcon, counter: 120},
    {navigation: 'Pull Requests', icon: GitPullRequestIcon, counter: 13},
    {navigation: 'Discussions', icon: CommentDiscussionIcon, counter: 5},
    {navigation: 'Actions', icon: PlayIcon, counter: 4},
    {navigation: 'Projects', icon: ProjectIcon, counter: 9},
    {navigation: 'Insights', icon: GraphIcon},
    {navigation: 'Settings', icon: GearIcon, counter: 10},
    {navigation: 'Security', icon: ShieldLockIcon}
  ]
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  return (
    <Box sx={{width: 750, border: '1px solid', borderBottom: 0, borderColor: 'border.default'}}>
      <UnderlineNav aria-label="Repository">
        {items.map((item, index) => (
          <UnderlineNav.Item
            key={item.navigation}
            icon={item.icon}
            aria-current={index === selectedIndex ? 'page' : undefined}
            onSelect={e => {
              setSelectedIndex(index)
              e.preventDefault()
            }}
            counter={item.counter}
          >
            {item.navigation}
          </UnderlineNav.Item>
        ))}
      </UnderlineNav>
    </Box>
  )
}
render(<Navigation />)
`}</code></pre>
    <h3>{`Loading State For Counters`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository" loadingCounters={true}>
  <UnderlineNav.Item counter={4} aria-current="page">
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item counter={44}>Issues</UnderlineNav.Item>
  <UnderlineNav.Item>Pull Requests</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`With React Router`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {Link, useMatch, useResolvedPath} from 'react-router-dom'
import {UnderlineNav} from '@primer/react/drafts'

function UnderlineNavItem({to, children, ...rest}) {
  const resolved = useResolvedPath(to)
  const isCurrent = useMatch({path: resolved.pathname, end: true})
  return (
    <UnderlineNav.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined} {...rest}>
      {children}
    </UnderlineNav.Item>
  )
}

const Navigation = () => {
  return (
    <UnderlineNav aria-label="Repository">
      <UnderlineNavItem to="/code" counter={4}>
        Code
      </UnderlineNavItem>
      <UnderlineNavItem to="/issues" counter={44}>
        Issues
      </UnderlineNavItem>
      <UnderlineNavItem to="/pulls">Pull Requests</UnderlineNavItem>
    </UnderlineNav>
  )
}
`}</code></pre>
    <h3>{`With Next.js`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useRouter} from 'next/router'
import Link from 'next/link'
import {UnderlineNav} from '@primer/react/drafts'

function UnderlineNavItem({href, children, ...rest}) {
  const router = useRouter()
  const isCurrent = typeof href === 'string' ? router.asPath === href : router.pathname === href.pathname
  return (
    <UnderlineNav.Item s={Link} href={href} aria-current={isCurrent ? 'page' : undefined} {...rest}>
      {children}
    </UnderlineNav.Item>
  )
}

const Navigation = () => {
  return (
    <UnderlineNav aria-label="Repository">
      <UnderlineNavItem href="/code" counter={4}>
        Code
      </UnderlineNavItem>
      <UnderlineNavItem href="/issues" counter={44}>
        Issues
      </UnderlineNavItem>
      <UnderlineNavItem href="/pulls">Pull Requests</UnderlineNavItem>
    </UnderlineNav>
  )
}
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`UnderlineNav`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="afterSelect" type="(event) => void" description="The handler that gets called when a nav link child is selected" mdxType="PropsTableRow" />
  <PropsTableRow name="aria-label" type="string" description="A unique name for the rendered 'nav' landmark. It will also be used to label the arrow
        buttons that control the scroll behaviour on coarse pointer devices. (I.e.
        'Scroll ${aria-label} left/right')
     " mdxType="PropsTableRow" />
  <PropsTableRow name="children" required type="UnderlineNav.Item[]" mdxType="PropsTableRow" />
  <PropsTableRow name="loadingCounters" type="boolean" defaultValue="false" description="Whether the navigation items are in loading state. Component waits for all the counters to finish loading to prevent multiple layout shifts." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`UnderlineNav.Item`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-current" type={`| 'page'
| 'step'
| 'location'
| 'date'
| 'time'
| true
| false`} defaultValue="false" description={<>
        Set <InlineCode mdxType="InlineCode">aria-current</InlineCode> to <InlineCode mdxType="InlineCode">"page"</InlineCode> to indicate that the item
        represents the current page. Set <InlineCode mdxType="InlineCode">aria-current</InlineCode> to <InlineCode mdxType="InlineCode">"location"</InlineCode> to
        indicate that the item represents the current location on a page. For more information about{' '}
        <InlineCode mdxType="InlineCode">aria-current</InlineCode>, see{' '}
        <Link href="https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current" mdxType="Link">MDN</Link>.
      </>} mdxType="PropsTableRow" />
  <PropsTableAsRow defaultElementType="a" mdxType="PropsTableAsRow" />
  <PropsTableRow name="counter" type="number" description="The number to display in the counter label." mdxType="PropsTableRow" />
  <PropsTableRow name="href" type="string" description="The URL that the item navigates to. 'href' is passed to the underlying '<a>' element. If 'as' is specified, the component may need different props and 'href' is ignored. (Required prop for the react router is 'to' for example)" mdxType="PropsTableRow" />
  <PropsTableRow name="icon" type="Component" description="The leading icon comes before item label" mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event) => void" description="The handler that gets called when a nav link is selected. For example, a manual route binding can be done here(I.e. 'navigate(href)' for the react router.)" mdxType="PropsTableRow" />
  <PropsTableBasePropRows passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes" mdxType="Link">MDN</Link>} elementType="a" mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: true,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      